import WithdrawList from '../views/transactionManagement/withdrawList'
import WithdrawMethod from '../views/transactionManagement/withdrawMethod'
import RechargeList from '../views/transactionManagement/rechargeList'
// import PayChannel from '../views/transactionManagement/payChannel'
import WithdrawBank from '../views/transactionManagement/withdrawBank'
import TransferList from '../views/transactionManagement/transferList'
import WithdrawRefund from '../views/transactionManagement/withdrawRefund'
import Main from '../views/main'

const TransactionRouter = {
  path: '/recharge-list',
  component: Main,
  title: '交易管理',
  icon: 'el-icon-sort',
  meta: { keepAlive: false },
  children: [
    {
      path: '/recharge-list',
      component: RechargeList,
      name: 'rechargeList',
      title: '充值订单管理',
      meta: { title: '充值订单管理' ,keepAlive:false}
    },
    // {
    //   path: '/pay-channel',
    //   component: PayChannel,
    //   name: 'payChannel',
    //   title: '支付通道管理',
    //   meta: { title: '支付通道管理' ,keepAlive:false}
    // },
    {
      path: '/withdraw-list',
      component: WithdrawList,
      name: 'withdrawList',
      title: '提现订单列表',
      meta: { title: '提现订单列表' ,keepAlive:true}
    },
    {
      path: '/withdraw-method',
      component: WithdrawMethod,
      name: 'withdrawMethod',
      title: '提现方式配置',
      meta: { title: '提现方式配置' ,keepAlive:true}
    },
    {
      path: '/withdraw-bank',
      component: WithdrawBank,
      name: 'withdrawBank',
      title: '提现银行配置',
      meta: { title: '提现银行配置' ,keepAlive:true}
    } ,
    {
      path: '/transfer-list',
      component: TransferList,
      name: 'transferList',
      title: '财务转账列表',
      meta: { title: '财务转账列表' ,keepAlive:true}
    },
    {
      path: '/withdraw-refund',
      component: WithdrawRefund,
      name: 'withdrawRefund',
      title: '提现退款列表',
      meta: { title: '提现退款列表' ,keepAlive:true}
    } ,    
  ]
}
export default TransactionRouter
